import b from 'b_';
import { SimpleCallback } from 'platform-components';
import React from 'react';
import { useSelector } from 'react-redux';

import Stats from 'common.components/lesson-view.stats/stats';
import ScrollBlock from 'common.components/scroll-block/scroll-block';

import ActionButton from '../__action-button/side-panel__action-button';
import { Controls } from '../__controls/side-panel__controls';
import CopyLessonLink from '../__copy-lesson-link/side-panel__copy-lesson-link';
import ExternalLink from '../__external-link/side-panel__external-link';
import { SidePanelFooter } from '../__footer/side-panel__footer';
import { SidePanelHeader } from '../__header/side-panel__header';
import LessonMode from '../__lesson-mode/side-panel__lesson-mode';
import LessonPeriod from '../__lesson-period/side-panel__lesson-period';
import LessonStatus from '../__lesson-status/side-panel__lesson-status';
import * as selectors from '../selectors';

interface Props {
    isMobile: boolean;
    onForceComplete?: SimpleCallback;
    isCopyingEnabled?: boolean;
    hideFooter?: boolean;
}

export const SidePanelModeLessonStats = React.memo(
    ({ isCopyingEnabled, isMobile, onForceComplete, hideFooter }: Props) => {
        const shouldShowCopyLinkInput = useSelector(selectors.getShouldShowCopyLinkInput);

        return (
            <>
                <SidePanelHeader>
                    <LessonMode />
                    <div className="side-panel__info">
                        <LessonPeriod />
                        <LessonStatus />
                    </div>
                    <ExternalLink />
                </SidePanelHeader>
                {/* даже на мобилках он всегда раскрыт, так как экспанд находится внутри статистики по дизайну */}
                <ScrollBlock mix={b('side-panel', 'scroll-block', { expanded: true })}>
                    <div className="side-panel__content">
                        <Stats />
                    </div>
                </ScrollBlock>
                {!hideFooter && (
                    <SidePanelFooter>
                        {shouldShowCopyLinkInput && !isMobile && <CopyLessonLink />}
                        <div className="side-panel__footer-controls">
                            <ActionButton onForceComplete={onForceComplete} />
                            <Controls isCopyingEnabled={isCopyingEnabled} isMobile={isMobile} />
                        </div>
                    </SidePanelFooter>
                )}
            </>
        );
    }
);
